import AmericamExpressCardIcon from "./american-express.svg";
import EloCardIcon from "./elo.svg";
import HiperCardCardIcon from "./hipercard.svg";
import HiperCardIcon from "./hiper.svg";
import MasterCardIcon from "./mastercard.svg";
import VisaCardIcon from "./visa.svg";
import AuraCardIcon from "./aura.svg";
import DiscoverCardIcon from "./discover.svg";
import DinersCardIcon from "./diners.svg";

export {
  AmericamExpressCardIcon,
  EloCardIcon,
  HiperCardIcon,
  HiperCardCardIcon,
  MasterCardIcon,
  VisaCardIcon,
  AuraCardIcon,
  DiscoverCardIcon,
  DinersCardIcon,
};
